// Client-side CSV building + download for the cashback weekend's live casino games. Kept free of
// React, same convention as flagged_chats/flaggedChatsExport.js.

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Same escaping as flagged_chats/flaggedChatsExport.js: quote-wrap + double internal quotes for
// fields containing a comma/quote/newline, and prefix an apostrophe on fields a spreadsheet app
// would otherwise run as a formula.
const escapeCsvField = (value) => {
  let str = value == null ? '' : String(value);
  if (/^\s*[=+\-@]/.test(str)) str = `'${str}`;
  return /[",\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

// The headers are the query's column names, so the file matches what the warehouse returns.
export const downloadLiveCasinoGamesCsv = (games) => {
  const rows = games.map((g) => [g.provider, g.title].map(escapeCsvField).join(','));
  const blob = new Blob([['provider,title', ...rows].join('\n')], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, `live_casino_games_${new Date().toISOString().slice(0, 10)}.csv`);
};
